<template>
 <router-view></router-view>

</template>

<script>
import { getSettings } from '@/helpers/settings-cache';
import { initializeDocumentSettings } from '@/helpers/document-utils';
import { updateLogoSettings } from '@/helpers/logo-utils';

export default {
  name: 'App',
  components: {
  },
  async mounted() {
    // Load general settings on app initialization (cached, only one API call)
    try {
      const res = await getSettings();
      if (res?.data) {
        // Initialize document settings
        initializeDocumentSettings({
          title: res.data.title,
          favicon: res.data.favicon
        });
        
        // Update logo settings from the same data (no additional API call)
        if (res.data.logo && typeof res.data.logo === 'string') {
          updateLogoSettings(
            res.data.logo,
            res.data.logo_width,
            res.data.logo_height
          );
        }
      }
    } catch (error) {
      // Settings not loaded, use defaults
      console.log('Settings not available on app load');
    }
  }
}

</script>
<style>
.search-box .search-icon{
  max-width: 20px;
}
</style>
